import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_WIDTH_HEADLINE_CONVERTER_TOKEN, FullWidthHeadlineConverter } from './full-width-headline.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthHeadlineFeature: {
          module: () => import('./full-width-headline.module').then((m) => m.FullWidthHeadlineModule),
          cmsComponents: ['full_width_headline'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_HEADLINE_CONVERTER_TOKEN,
      useExisting: FullWidthHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_headline: FULL_WIDTH_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthHeadlineFeatureModule {}
